import React, {Component} from 'react';
import {connect} from "react-redux";
import {Button, Col, Divider, PageHeader, Row} from 'antd';
import {notNull, openEndPoint} from "../utils/utils";
import {get} from "../helper/request";

export class Videos extends Component {

    constructor(props) {
        super(props);

        this.state = {
            allVideos: {},
            deviceId: this.props.match.params.id,
        }
    }

    componentDidMount = () => {
        this.getVideos();
    }

    getVideos = () => {
        let url = "/api/videos/"
        get(url)
            .then(data => {
                var allVideos = {};
                for (var i = 0; i < data.length; i++) {
                    let video = data[i];
                    allVideos[video.id] = video;
                }
                this.setState({
                    allVideos,
                });
            })
            .catch(err => {
                console.log("Failed request", err);
            });
    }

    renderVideos = (videos) => {
        let ids = Object.keys(videos);
        let videosComponent = [];
        for (let i = 0; i < ids.length; i += 4) {
            videosComponent.push(
                <Row style={{marginTop: 10, marginBottom: 10}}>
                    {
                        notNull(ids[i]) ?
                            this.getVideoThumbnail(videos[ids[i]]) :
                            null
                    }
                    {
                        notNull(ids[i + 1]) ?
                            this.getVideoThumbnail(videos[ids[i + 1]]) :
                            null
                    }
                    {
                        notNull(ids[i + 2]) ?
                            this.getVideoThumbnail(videos[ids[i + 2]]) :
                            null
                    }
                    {
                        notNull(ids[i + 3]) ?
                            this.getVideoThumbnail(videos[ids[i + 3]]) :
                            null
                    }
                </Row>
            )
        }
        return videosComponent;
    }

    getVideoThumbnail = (video) => {
        const isLongDesc = video.description.length > 150;
        const descElem = (
            <div>{isLongDesc ? `${video.description.slice(0, 150)}...` : video.description}</div>
        );
        return (
            <Col offset={1} span={5}>
                <div style={{width: 300, cursor: 'pointer'}} onClick={() => this.goToVideo(video.id)}>
                    <Row>
                        <img src={video.thumbnail_url} alt={"video thumbnail"} width={300} height={200}/>
                    </Row>
                    <Row style={{textAlign: 'center'}}>
                        <b style={{fontSize: '1.4rem', fontWeight: 500}}>{video.name}</b>
                    </Row>
                    <Row style={{textAlign: 'justify'}}>
                        {descElem}
                    </Row>
                </div>
            </Col>
        )
    }

    goToVideo = (id) => {
        openEndPoint("/video-viewer/" + id, false, true);
    }

    goToSettings = (e) => {
        openEndPoint("/scanner_settings/" + this.state.deviceId, false, true);
    }

    render() {

        let videosComponent = undefined;

        videosComponent = this.renderVideos(this.state.allVideos);

        return (
            <div>
                <Row>
                    <Col offset={10} span={10}>
                        <PageHeader style={{backgroundColor: "#ffffff00", paddingBottom: "10px"}}
                                    title="Helper Guide"></PageHeader>
                    </Col>
                    <Col span={4} style={{padding: '16px 24px'}}>
                        <Button type="primary" onClick={this.goToSettings} ghost>
                            Back to Settings
                        </Button>
                    </Col>
                </Row>
                <Divider/>
                {videosComponent}
            </div>
        )
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};

export default connect(mapStateToProps)(Videos);
